module.exports = __webpack_public_path__ + "img/logo-ptn.66062b2d.png";